import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { CustomTable } from '../../components/CustomTable';
import { ProgressBarGradient } from '../../components/ProgressBarGradient';
import { customPalette } from '../../themes/customTheme';
import { hasRole } from '../../utils/roles';
import { transformGoals } from './utils';

const getMonthName = dateString => {
  let newDate = new Date(dateString);
  let month = newDate.toLocaleString('es', { month: 'long', timeZone: 'UTC' });
  month = month.charAt(0).toUpperCase() + month.slice(1);

  const year = newDate.getFullYear();
  return `${month} ${year}`;
};

const Row = ({ item }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <TableRow>
        <TableCell
          sx={{
            backgroundColor: open
              ? customPalette.background.default
              : undefined,
            width: '40px',
          }}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
          </IconButton>
        </TableCell>
        <TableCell
          sx={open ? { backgroundColor: customPalette.background.default } : {}}
        >
          {item[0].team?.name || '(sin datos)'}
        </TableCell>
        <TableCell
          sx={open ? { backgroundColor: customPalette.background.default } : {}}
        >
          {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
            item[0].visits
          )}
          {' (' + item[0].percentage_visits + '%)'}
        </TableCell>
        <TableCell
          sx={open ? { backgroundColor: customPalette.background.default } : {}}
        >
          {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
            item[0].notes
          )}
          {' (' + item[0].percentage_notes + '%)'}
        </TableCell>
        <TableCell
          sx={open ? { backgroundColor: customPalette.background.default } : {}}
        >
          {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
            item[0].rfv
          )}
          {' ('}
          {item[0].percentage_rfv == 0 ? '0%)' : '100%)'}
        </TableCell>
        <TableCell
          sx={open ? { backgroundColor: customPalette.background.default } : {}}
        >
          {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
            item[0].subscribers
          )}
          {' (' + item[0].percentage_subscribers + '%)'}
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: open
              ? customPalette.background.default
              : undefined,
            display: 'flex',
            alignItems: 'center',
            padding: '12px !important',
            maxWidth: '280px',
          }}
        >
          <ProgressBarGradient percentage={item[0].progress.average_progress} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ padding: 0, margin: 0 }}>
              <CustomTable
                key={`Porcentaje del puntaje-${item[0].team?.id || '0'}`}
                title="Porcentaje del puntaje"
                subtitles={['Notas', 'Vistas', 'Calidad', 'Suscriptos']}
                values={[
                  item[0].point_notes + '%',
                  item[0].point_visits + '%',
                  item[0].point_rfv + '%',
                  item[0].point_subscribers + '%',
                ]}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export const GoalsCurrentMonth = ({ month, goals }) => {
  const translate = useTranslate();
  const navigate = useNavigate();
  if (!goals) return null;
  const handleClick = () => {
    const data = transformGoals(goals);
    navigate('/goals/edit', { state: { ...data } });
  };
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '24px',
        borderRadius: '20px',
        marginTop: '16px',
      }}
      elevation={0}
    >
      <Box
        flexDirection={{ xs: 'column', sm: 'row' }}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingBottom: '10px',
          rowGap: '12px',
        }}
      >
        <CardHeader
          title={month ? `Objetivos de ${getMonthName(month)}` : 'Objetivos'}
          sx={{
            padding: '0',
          }}
        />
        {hasRole(['admin', 'gerente']) ? (
          <Button variant="outlined" onClick={() => handleClick()}>
            {translate('resources.goals.edit.title')}
          </Button>
        ) : null}
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '40px' }} />
              <TableCell>{translate('resources.goals.fields.team')}</TableCell>
              <TableCell>{translate('resources.goals.fields.visit')}</TableCell>
              <TableCell>{translate('resources.goals.fields.notes')}</TableCell>
              <TableCell>{translate('resources.goals.fields.rfv')}</TableCell>
              <TableCell>
                {translate('resources.goals.fields.subscribers')}
              </TableCell>
              <TableCell
                sx={{ paddingLeft: '12px !important', width: '280px' }}
              >
                {translate('resources.goals.fields.status')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(goals).map(([_key, item], i) => (
              <Row key={i} item={item} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};
